/** Injected at build time by scripts/ng-with-env.mjs (`--define`); absent in unit tests. */
declare const APP_BUILD:
  { version: string; commit: string; stage: string; builtAt: string } | undefined;

export const BUILD =
  typeof APP_BUILD === 'undefined'
    ? { version: '', commit: '', stage: '', builtAt: '' }
    : APP_BUILD;

/** e.g. "v1.0.0 · a1b2c3d · dev"; production shows no stage. */
export function versionLabel(build = BUILD): string {
  return [
    build.version && `v${build.version}`,
    build.commit,
    build.stage !== 'production' && build.stage,
  ]
    .filter(Boolean)
    .join(' · ');
}
